import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { TeamOutlined, UserOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';

import { useSelector } from 'react-redux';
import { RootState } from '../../../application/store';
import { BVMenuItem, BVMenuItemProps } from './bv-menu-item';
import './bv-sidebar-nav.scss';

const { Sider } = Layout;

const BVSidebarNav: React.FunctionComponent = () => {
	const [collapsed, setCollapsed] = useState(true);
	const history = useHistory();
	const isAdmin = useSelector((state: RootState) => state.system.isAdmin);
	const _handleNavigation = (location: string) => history.push(location);
	const menuItems: (BVMenuItemProps & { needAdmin: boolean })[] = [
		{
			title: 'Admin Area',
			onClick: () => _handleNavigation('/admin'),
			icon: <UserOutlined />,
			needAdmin: true,
		},
		{
			title: 'Customers',
			onClick: () => _handleNavigation('/'),
			icon: <TeamOutlined />,
			needAdmin: false,
		},
	];

	return (
		<Sider
			className="bv-sidebar-nav-sider"
			collapsed={collapsed}
			collapsible
			collapsedWidth={50}
			width={'15%'}
			onCollapse={(e) => setCollapsed(e)}
		>
			{!collapsed && (
				<Menu className="bv-sidebar-nav" mode="inline">
					{menuItems
						.filter((i) => !i.needAdmin || isAdmin)
						.map((i) => (
							<BVMenuItem {...i} />
						))}
				</Menu>
			)}
		</Sider>
	);
};

export default BVSidebarNav;
